import { SxProps } from '@mui/material';

export const sxTranscricaoResumoCard: SxProps = {
  borderRadius: '16px',
  width: '100%',
  boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08)',
  padding: '24px 32px',
  display: 'grid',
  gridTemplateColumns: 'repeat(5, minmax(0, 1fr))',
  gap: '24px 16px',
  '@media (max-width: 1199px)': {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  },
};

export const sxTranscricaoResumoCardMobile: SxProps = {
  borderRadius: '8px',
  width: '100%',
  boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08)',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
};

export const sxTranscricaoDetalheTabs: SxProps = {
  width: '100%',
  marginTop: '24px',
  '& .MuiTabs-indicator': {
    height: '4px',
    backgroundColor: '#00995D',
  },
};

export const sxTranscricaoDetalheTab: SxProps = {
  fontFamily: 'UnimedSans-Bold, Unimed-Sans, sans-serif',
  fontSize: '16px',
  fontWeight: 700,
  textTransform: 'none',
  color: '#383838',
  flex: '1 1 0',
  maxWidth: 'unset !important',
  padding: '12px 16px',
  borderBottom: '4px solid #BDBDBD',
  '&.Mui-selected': {
    color: '#383838',
  },
};
